import {
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { useGlobalModal } from "@/hooks/useGlobalModal";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import type { Matter, MatterSubItemType } from "@/lib/types";
import { CheckSquare, ListTodo, Plus } from "lucide-react";

interface MatterSubItemTasksContextMenuProps {
  matter: Matter;
  onOpenTasks: () => void;
  subItem: {
    id: string;
    type: MatterSubItemType;
  };
}

export const MatterSubItemTasksContextMenu = ({
  matter,
  onOpenTasks,
  subItem,
}: MatterSubItemTasksContextMenuProps) => {
  const { hasActionPermission } = useUser();
  const { openTaskModal } = useGlobalModal();
  const canCreateTasks = hasActionPermission(
    ACTION_PERMISSION_KEYS.matter,
    ACTION_PERMISSION_VALUES.update,
  );

  return (
    <>
      <ContextMenuSub>
        <ContextMenuSubTrigger>
          <CheckSquare />
          Tasks
        </ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <ContextMenuItem
            onSelect={() => {
              onOpenTasks();
            }}
          >
            <ListTodo />
            Open tasks
          </ContextMenuItem>
          {canCreateTasks ? (
            <ContextMenuItem
              onSelect={() => {
                openTaskModal({
                  matterId: matter.id,
                  editing: false,
                  initialTab: "details",
                  subItem,
                  hideMatterField: true,
                });
              }}
            >
              <Plus />
              Create task
            </ContextMenuItem>
          ) : null}
        </ContextMenuSubContent>
      </ContextMenuSub>
    </>
  );
};
